var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 10.7803C19.59 7.68027 22.6 4.56973 25.6 1.46973L34.61 10.7803",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8099 38.9404L22.7899 29.5703H28.3899L28.3999 38.9404",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0499 17.2998H22.1299L22.1499 21.9697H29.0599L29.0499 17.2998Z",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8099 10.4697L16.8499 38.9404",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.35 10.4697L34.38 38.9404",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1599 3.94043H6.80994L2.29993 10.7803H16.8399",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 38.9404H4.8999V10.7803",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3299 18.6201V15.4902H40.7499H39.1799",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3299 26.9805V23.8496H40.7499H39.1799",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3299 35.3398V32.21H40.7499H39.1799",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.87 18.6201V15.4902H10.3H8.72998",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.87 26.9805V23.8496H10.3H8.72998",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.87 35.3398V32.21H10.3H8.72998",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.94043H44.34L48.85 10.7803H34.35",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3599 38.9404H46.2599V10.7803",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.85 38.9404H34.38",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26 38.9404H48.4",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76001 38.9404H4.89999",
    stroke: "#322D60",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldBuilding);
export default __webpack_public_path__ + "static/media/oldBuilding.a0f2b73d2968aa7d1ed582b3a4e5006a.svg";
export { ForwardRef as ReactComponent };